// extracted by mini-css-extract-plugin
export default {"bg":"bg_bg__wQuYp"};